import React from 'react';
import SearchDropdown from './SearchDropdown';
import SearchInput from './SearchInput';
import { useSearchBar } from './useSearchBar';
import './searchBar.scss';

const SearchBar = () => {
  const {
    dropdownVisible,
    inputOpen,
    inputRef,
    isSearchPanelOpen,
    query,
    results,
    searchState,
    shouldRenderDropdown,
    wrapperRef,
    closeSearch,
    handleQueryChange,
    handleResultClick,
    handleSearch,
    hasInteracted,
  } = useSearchBar();

  return (
    <div className={`wrapper ${inputOpen ? 'search-open' : ''} ${isSearchPanelOpen ? 'search-active' : ''}`} ref={wrapperRef}>
      <SearchInput
        inputOpen={inputOpen}
        inputRef={inputRef}
        isSearchPanelOpen={dropdownVisible && inputOpen}
        hasInteracted={hasInteracted}
        query={query}
        onQueryChange={handleQueryChange}
        onSearch={handleSearch}
      />

      {shouldRenderDropdown && (
        <SearchDropdown
          error={searchState.error}
          isOpen={isSearchPanelOpen}
          materialImages={searchState.materialImages}
          results={results}
          status={searchState.status}
          onClose={closeSearch}
          onResultClick={handleResultClick}
        />
      )}
    </div>
  );
};

export default SearchBar;
